var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-10 py-5 mt-15"},[_c('v-row',{staticClass:"mb-15"},[_c('v-col',{staticClass:"py-5 mx-auto",attrs:{"col":"12","lg":"4","md":"4"}},[_c('v-card',{staticClass:"elevation-0 text-align:center",attrs:{"dark":"","color":"transparent"}},[_c('h1',[_vm._v("Coming soon")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }